import { useDispatch, useSelector } from "react-redux";
import { IStore, IAvailabilityStepInfo, Step } from "../../../DataTypes/storeTypes";
import { Button } from "@powerdiary/components-library/lib";
import { navigateNext, navigateBefore } from "../../../Actions/availabilityActions";
import { getShowingDateByInfo } from "../../../Helpers/calendarHelper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

export const Navigation = () => {
    const { canNavigateBefore, date } = useSelector((state: IStore) => {
        const info = state.stepsInfo[Step.When] as IAvailabilityStepInfo;
        const date = getShowingDateByInfo(info);
        const monthAgo = date.clone().startOf("month").subtract(1, "month");

        const year = monthAgo.year();
        const month = monthAgo.format("MM");

        let canNavigateBefore = !!(state.availability && state.availability[year] && state.availability[year][month]);

        return {
            canNavigateBefore: canNavigateBefore,
            date: date,
        };
    });
    const dispatch = useDispatch();

    return (
        <div className="control">
            <Button
                variant="outlined"
                size="small"
                onClick={() => dispatch(navigateBefore())}
                disabled={!canNavigateBefore}
                className="ml-2"
            >
                <FontAwesomeIcon icon={faChevronLeft} />
            </Button>

            <span className="month">{date.format("MMMM")}</span>

            <Button variant="outlined" size="small" onClick={() => dispatch(navigateNext())} className="mr-2">
                <FontAwesomeIcon icon={faChevronRight} />
            </Button>
        </div>
    );
};
